/**
 * @generated SignedSource<<b8590483fd866388b7414c2f9e05850c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavItem_notifications$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NavItemBadge_notifications">;
  readonly " $fragmentType": "NavItem_notifications";
};
export type NavItem_notifications$key = {
  readonly " $data"?: NavItem_notifications$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavItem_notifications">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavItem_notifications",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItemBadge_notifications"
    }
  ],
  "type": "DealerNavBarBadges",
  "abstractKey": null
};

(node as any).hash = "851c324c2aa0216c327fab2bb30daec7";

export default node;
